<template>
    <div class="row">
        <div class="col-12">
            <p class="text-small text-primary mb-2 font-weight-bold">{{trans('courses.multicircle_exercise.step_1')}}</p>
            <h4 class="text-primary mb-4">{{trans('courses.multicircle_exercise.add_roles_end_title')}}</h4>
        </div>

        <div class="col-12">
            <p class="text-caption">
                {{trans('courses.multicircle_exercise.add_roles_end_description')}}
            </p>
        </div>

        <div class="col-12">
            <multicircle-graph :roles="roles"/>
        </div>

        <div class="col-12 d-flex justify-content-end">
            <b-button variant="secondary" @click="$emit('next')">
                {{trans('courses.multicircle_exercise.next')}}
            </b-button>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    import MulticircleGraph from "./MulticircleGraph";

    export default {
        name: "AddRolesEnd",
        components:{ MulticircleGraph },
        computed: {
            ...mapGetters({
                roles: 'multime/getSavedRoles'
            })
        }
    }
</script>

<style scoped>

</style>